export const DROPDOWN_WIDTH = 178;
export const DOMAINS_MANAGEMENT_SUBMIT_DD_ANCHOR = "domains-management-submit-dd-anchor";
